module.exports = __webpack_public_path__ + "img/point.b619cd4d.svg";